import { InternalActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { InternalFormData } from 'src/screens/General/screens/Internals/components/InternalForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetInternalsAction {
    type: typeof InternalActions.FETCH_INTERNALS;
    payload: QueryParams;
    all?: any;
}

export function getInternals(params: QueryParams): GetInternalsAction {
    return {
        type: InternalActions.FETCH_INTERNALS,
        payload: params,
    };
}
interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getInternalsCsv(params: QueryParamsAll): GetInternalsAction {
    return {
        type: InternalActions.FETCH_INTERNALS_CSV,
        payload: params,
        all: params.all,
    };
}

export interface GetInternalAction {
    type: typeof InternalActions.FETCH_INTERNAL;
    payload: {
        id: string | number;
    };
}

export function getInternal(id: string | number): GetInternalAction {
    return {
        type: InternalActions.FETCH_INTERNAL,
        payload: { id },
    };
}

export interface DeleteInternalAction {
    type: typeof InternalActions.DELETE_INTERNAL;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteInternal(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteInternalAction {
    return {
        type: InternalActions.DELETE_INTERNAL,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistInternalAction {
    type: typeof InternalActions.PERSIST_INTERNAL;
    payload: {
        data: InternalFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistInternal(data: InternalFormData, callbacks: SagaPromise<any>): PersistInternalAction {
    return {
        type: InternalActions.PERSIST_INTERNAL,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistInternal = (data: InternalFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistInternal(data, { resolve, reject }));
    });
};

export type Actions = GetInternalsAction | GetInternalAction | DeleteInternalAction | PersistInternalAction;
